import React from 'react';

import styles from './basicInformation.module.scss';

export default function PaymentMethods(props: { payments: { text: string; icon: JSX.Element }[] }) {
  const halfwayPoint = Math.ceil(props.payments.length / 2);
  const columnA = props.payments.slice(0, halfwayPoint);
  const columnB = props.payments.slice(halfwayPoint);

  return (
    <div data-testid="paymentMethods-wrapper" className={styles.paymentMethodWrapper}>
      <div className={styles.paymentColumn}>
        {columnA.map((item, index, i) => {
          return (
            <div key={`${item.text}-${index}`} className={styles.paymentContent}>
              {item.icon} {item.text}
            </div>
          );
        })}
      </div>
      <div className={styles.paymentColumn}>
        {columnB.map((item, index, i) => {
          return (
            <div key={`${item.text}-${index}`} className={styles.paymentContent}>
              {item.icon} {item.text}
            </div>
          );
        })}
      </div>
    </div>
  );
}
